import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export const isValidSimulationPreset = properties => {
  const ans = isValidBase(properties) && validateProps(properties, ['name', 'description', 'initialNoteExamples', 'additionalNoteExamples', 'simulationSize', 'eventTemplates']);
  return ans;
};
//# sourceMappingURL=SimulationPreset.js.map